#canvas{width:100%!important;height:auto!important;aspect-ratio:unset!important;max-height:500px}.chart{padding:1em;border:1px solid #d8d8d8;background:#fff;margin-bottom:3em}
/*# sourceMappingURL=vital-signs-chart.component-AYGVCJGR.css.map */
